import React, { useContext, useState, useEffect } from "react";
import "./Dashboard.css";
import Buckets from "../Common_Component/Buckets/Buckets";
import Table_Heading from "../Common_Component/Table_Heading/Table_Heading";
import New_User_Table from "./New_User_Table/New_User_Table";
import { Form, Table } from "react-bootstrap";
import Border_btn from "../Common_Component/Border_btn/Border_btn";
import { Context } from "../../utils/context";
import { findAll } from "../../utils/apis/dashboard/dashboard";
import Pei_Chart from "../Common_Component/Pei_Chart/Pei_Chart";
import Donut_Chart from "../Common_Component/Donut_Chart/Donut_Chart";
import Polar_Area_Chart from "../Common_Component/Polar_Area_Chart/Polar_Area_Chart";
import { Link } from "react-router-dom";
import Heading_Holder from "../Common_Component/Heading_Holder/Heading_Holder";
import { formatAmount } from "../../utils/common";

function Dashboard() {
  const { UnauthorizedLogOut } = useContext(Context);
  const [data, setData] = useState([]);
  const getDataAll = async () => {
    try {
      const response = await findAll();
      await setData(response?.data);
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };
  useEffect(() => {
    getDataAll();
  }, []);

  const today = new Date().toISOString().split("T")[0];

  const bucketData = [
    {
      BucketText: "Total Customers",
      divText: data?.data?.total_users || 0,
      api: "/agent-management/customer",
    },
    // {
    //   BucketText: "Total Active Users",
    //   divText: data?.data?.total_active_users || 0,
    //   api: "/agent-management/customer",
    // },
    {
      BucketText: "Total In-Active Users",
      divText: `₹ ${data?.data?.total_inactive_users || 0}`,
      api: "/agent-management/customer?status=0",
    },
    {
      BucketText: "Total Wallet Amount",
      divText: `${formatAmount(data?.data?.total_wallet_amount) || 0}`,

      api: "/wallet/history",
    },
    {
      BucketText: "Todays Deposits",
      divText: `${formatAmount(data?.data?.todays_deposite_money) || 0}`,
      api: `/wallet/history?wallet_type=3&date=${today}`,
    },
    {
      BucketText: "Todays Withdraws",
      divText: `${formatAmount(data?.data?.todays_withdraw_money) || 0}`,
      api: `/wallet/accept?date=${today}`,
    },
  ];

  if (data?.data?.customers_wallet) {
    bucketData.unshift({
      BucketText: "Total Customers Wallet Balance",
      divText: data?.data?.customers_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.agents_wallet) {
    bucketData.unshift({
      BucketText: "Total Agents Wallet Balance",
      divText: data?.data?.agents_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.total_agency_balance) {
    bucketData.unshift({
      BucketText: "Total Justbooking Balance",
      divText: data?.data?.total_agency_balance || 0,
      api: "/dashboard",
    });
  }
  return (
    <section className="Dashboard">
      <Heading_Holder headingText={"Dashboard"} />
      <div className="row mb-5">
        {bucketData.map((bucket, index) => (
          <div
            key={index}
            className="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4 mt-3">
            <Link to={bucket?.api}>
              <div className="buckets-holder">
                <Buckets
                  BucketText={bucket.BucketText}
                  divText={bucket.divText}
                />
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* <div className="row">
        <div className=" col-xxl-3 col-xl-4 col-lg-6 col-md-6">
          <div className="chart-holder">
            <Pei_Chart response={data?.data?.pie_chart} />
          </div>
        </div>

        <div className=" col-xxl-3 col-xl-4 col-lg-6 col-md-6">
          <div className="chart-holder">
            <Donut_Chart response={data?.data?.donut_chart} />
          </div>
        </div>

        <div className=" col-xxl-3 col-xl-4 col-lg-6 col-md-6">
          <div className="chart-holder">
      <Polar_Area_Chart response={data?.data?.polar_area} />
    </div>
        </div >
      </div > */}

      {/* <div className="row">
        <div className="col-xl-6 col-lg-12 col-md-12">
          <div className="table-holder">
            <Table_Heading tableHeading={"New User"} />

            <div className="main-table-holder">
              <New_User_Table />
              <div className="data-table-holder">
                <Table responsive bordered  className=" table-condensed table-striped ">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Name</th>
                      <th>Mobile Number</th>
                      <th >Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>01</td>
                      <td>Rimsha Pethe</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>02</td>
                      <td>Paresh M</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>03</td>
                      <td>Mandar J</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>04</td>
                      <td>Praful P</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >
                        <Form>
                          <Form.Check type="switch" id="custom-switch" />
                        </Form>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>

        <div className=" col-xl-6 col-lg-12 col-md-12">
          <div className="table-holder">
            <Table_Heading tableHeading={"Todays Played"} />

            <div className="main-table-holder">
              <New_User_Table />

              <div className="data-table-holder">
                <Table responsive bordered  className="table-striped ">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Name</th>
                      <th>Mobile Number</th>
                      <th >Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>01</td>
                      <td>Rimsha Pethe</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>
                    <tr>
                      <td>02</td>
                      <td>Paresh M</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>
                    <tr>
                      <td>03</td>
                      <td>Mandar J</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>04</td>
                      <td>Praful P</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>

                    <tr>
                      <td>05</td>
                      <td>Swapnil Patil</td>
                      <td>+91 1234567890</td>
                      <td >₹. 100/-</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="view-all-btn">
        <Border_btn btnText={"View All"} baseLink={"/view-list"} />
      </div> */}
    </section>
  );
}

export default Dashboard;
